export class Center {
  code : string;
  description : string;
}
